import {Route, Routes} from 'react-router-dom'
import { DeviceStatistics } from './components/DeviceStatistics'

export const DashboardRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<DeviceStatistics />} />
    </Routes>
  )
}
